<template lang="pug">
  b-modal#raiseDepositTicket(
  ref="raiseDepositTicket"
  :title="$t('ui.combine.raise_deposit_ticket')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
  )
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$t('ui.account_id')" disabled).mb-0
        DebounceInput(
          size="sm"
          ref="account_id"
          required
          alphaNum
          type="text"
          :dirty="$v.account_id.$dirty"
          :error="$v.account_id.$error"
          v-model.trim.lazy="$v.account_id.$model"
          :disabled="loading"
          :maxLength="$v.account_id.$params.maxLength.max"
        )
        ValidateResult(:value="$v.account_id" :name="$t('ui.account_id')")
      b-form-group(:label="$t('ui.amount')").mb-0
        DebounceInput(
          size="sm"
          ref="deposit_amount"
          required
          type="text"
          :dirty="$v.deposit_amount.$dirty"
          :error="$v.deposit_amount.$error"
          v-model.trim.lazy="$v.deposit_amount.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.deposit_amount" :name="$t('ui.amount')")
      b-form-group(:label="$t('ui.ref_no')").mb-0
        DebounceInput(
          size="sm"
          ref="ref_no"
          required
          alphaNum
          type="text"
          :dirty="$v.ref_no.$dirty"
          :error="$v.ref_no.$error"
          v-model.trim.lazy="$v.ref_no.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.ref_no" :name="$t('ui.ref_no')")
      b-form-group(:label="$tc('ui.banks', 1)").mb-0
        BankListDeposit(
          ref="bank"
          size="sm"
          type="array"
          :dirty="$v.bank.$dirty"
          :error="$v.bank.$error"
          v-model.trim.lazy="$v.bank.$model"
          :disabled="loading"
          :operatorID="operatorID"
        )
        ValidateResult(:value="$v.bank" :name="$tc('ui.banks', 1)")
      b-form-group(:label="$t('ui.deposit_date')").mb-0
        b-input-group(size="sm")
          date-picker.form-control-sm(
            ref="deposit_date"
            :config="locale"
            :dirty="$v.deposit_date.$dirty"
            :error="$v.deposit_date.$error"
            v-model.trim.lazy="$v.deposit_date.$model"
            :disabled="loading"
          )
        ValidateResult(:value="$v.deposit_date" :name="$t('ui.deposit_date')")
      b-form-group(:label="$t('ui.deposit_method')").mb-0
        DepositMethod(
          ref="deposit_method"
          size="sm"
          required
          type="array"
          :dirty="$v.deposit_method.$dirty"
          :error="$v.deposit_method.$error"
          v-model.trim.lazy="$v.deposit_method.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.deposit_method" :name="$t('ui.deposit_method')")
      b-form-group(:label="$t('ui.promotion')").mb-0
        //- PromotionLookup(
        //-   ref="promotion_id"
        //-   size="sm"
        //-   required
        //-   type="array"
        //-   v-model="promotion_id"
        //-   :disabled="loading"
        //- )
        b-form-select(v-model="promotion_id" size="sm" :disabled="loading")
          option(value="" selected) {{ $t("message.select_option") }}
          option(v-for="option in promoList" :value="option.promotion_id") {{ option.promotion_id }} - {{ option.promotion_name }}
      b-form-group(:label="$t('ui.remark')").mb-3
        b-form-textarea(v-model="remark" style="height:80px;" :disabled="loading")
        ValidateResult(:value="$v.remark" :name="$t('ui.remark')")
      //- div.row
      //-   div.col
      //-     b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>
<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal, maxValue } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import BankListDeposit from "@/library/BankListDeposit";
import DepositMethod from "@/library/DepositMethod";
import PromotionLookup from "@/library/PromotionLookup";
import DebounceInput from "@/library/DebounceInput";
const greaterThanZero = (value) => value > 0;

export default {
  components: {
    SubmitButton,
    DebounceInput,
    ValidateResult,
    BankListDeposit,
    DepositMethod,
    PromotionLookup
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: false,
        status: errorTags.request.failed
      },
      locale: {
        format: "YYYY-MM-DD HH:mm:ss",
        useCurrent: true
      },
      account_id: '',
      deposit_amount: '',
      bank: '',
      ref_no: '',
      deposit_date: '',
      deposit_method: '',
      promotion_id: '',
      remark: '',
      hideBankAccType: ['OUTGOING'],
      hideBankId: ['GATEWAY'],
      promoList: []
    };
  },
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
  },
  validations: {
    account_id: {
      required,
      alphaNum,
      maxLength: maxLength(20)
    },
    deposit_amount: {
      required,
      decimal,
      greaterThanZero
    },
    bank: {
      required
    },
    ref_no: {
      required,
      alphaNum,
      maxLength: maxLength(20)
    },
    deposit_date: {
      required
    },
    deposit_method: {
      required
    },
    remark: {
      required
    }
  },
  methods: {
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    getPromotionList: function() {
      let url = config.promotionLookupDepositUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        member_id: this.item.account_id
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.promoList = response.data.dt.filter(d => { return d.promotion_id != null && d.payment_option_list == null && d.status == true });
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.ticketDepositApproveUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          member_id: this.item.account_id,
          deposit_amount: this.deposit_amount,
          target_bank_id: this.bank.split(' - ')[0].trim(),
          target_bank_acc_no: this.bank.split(' - ')[1].trim(),
          // target_bank_acc_holder: this.bank.split(' - ')[2].trim(),
          ref_no: this.ref_no,
          deposit_date: this.deposit_date,
          deposit_method: this.deposit_method,
          promotion_id: this.promotion_id,
          remark: this.remark,
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.raiseDepositTicket.hide();
                } else {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  // this.$helpers.handleFeedback(this.feedback.status);
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.account_id = this.item.account_id;
      this.deposit_amount = '';
      this.bank = '';
      this.ref_no = '';
      this.deposit_date = this.$moment(new Date).format('YYYY-MM-DD HH:mm:ss');
      this.deposit_method = '';
      this.promotion_id = '';
      this.remark = '';
      this.getPromotionList();
      this.$v.$reset();
      this.$refs.deposit_amount.$el.focus();
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
